

    import * as T from '@/catalog-app/types';
    import { defineComponent, PropType } from 'vue';

    export default defineComponent({
        name: 'Breadcrumbs',
        props: {
            catalogName: String,
            brand: {
                type: Object as PropType<T.Category>,
            },
            breadcrumbs: {
                type: Array as PropType<T.Breadcrumb[]>,
                required: true,
            },
        },
        setup() {
            return {};
        }
    });
